import LeftCard from "components/MainPageCards/LeftCard";
import {useTranslation} from "react-i18next";
import { ReactComponent as UserIcon } from 'assets/icons/user.svg';
import { ReactComponent as LocationIcon } from 'assets/icons/location.svg';
import { ReactComponent as SocialIcon } from 'assets/icons/social.svg';
import RightCard from "components/MainPageCards/RightCard";

function App() {
    const { t } = useTranslation();

    const listItems = [
        {
            icon: UserIcon,
            text: t('default.list.contactsAndProfiles')
        },
        {
            icon: LocationIcon,
            text: t('default.list.locationsAndActivities')
        },
        {
            icon: SocialIcon,
            text: t('default.list.mediaAndPublic')
        }
    ];

  return (
    <div className="wrapper">
      <div className="main_container" >
        <div>
          <LeftCard
              list={listItems}
              mainTitle={t('default.mainTitle')}
              subTitle={t('default.subtitle')}
              solutionTitle={t('default.solutionTitle')}
          />
        </div>
          <RightCard />
      </div>
    </div>
  );
}

export default App;
